import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchData = () => ({
  type: types.FETCH_DATA,
});

const setWarningModalVisibility = visible => ({
  type: types.CHANGE_WARNING_CONTAINER_VISIBILITY,
  visible,
});

const updateTableAction = action => ({
  type: types.UPDATE_TABLE_ACTION,
  action,
});

const updateConfigStatus = () => ({
  type: types.UPDATE_CONFIG_STATUS,
});

export {
  init,
  fetching,
  fetchData,
  setWarningModalVisibility,
  updateTableAction,
  updateConfigStatus,
};
